/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @enum {string}
 */

export const PhoneType = {
  Work: "WORK",
  Home: "HOME",
  Cell: "CELL",
  Mobile: "MOBILE",
} as const;

export type PhoneType = (typeof PhoneType)[keyof typeof PhoneType];

export type PhoneTypeEnumType = typeof PhoneType;
export type PhoneTypeOptional = PhoneType;
export type PhoneTypeTrackedI = PhoneType;
export type PhoneTypeTracked = PhoneType;
export type PhoneTypeMetaI = EnumMetaType<PhoneTypeEnumType, PhoneType>;
export const PhoneTypeMeta = typeMetaEnum<PhoneTypeEnumType, PhoneType>(
  "PhoneType",
  PhoneType,
);
export function transformDatesPhoneType(model: PhoneType) {}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
